const navigation = (() => {
    const _o = {
        menuTrigger: document.querySelector("[data-menu-trigger]"),
        menuWrapper: document.querySelector("[data-menu-wrapper]"),
        body: document.querySelector("body")
    };

    const init = () => {
        if(_o.menuTrigger) {
            _o.menuTrigger.addEventListener("click", (e) => onClickMenuTrigger(e, _o.menuTrigger));
            window.addEventListener("resize", () => close());
        }
    };

    const onClickMenuTrigger = (e, trigger) => {
        trigger.classList.toggle("active");
        _o.menuWrapper.classList.toggle("active");
        _o.body.classList.toggle("nav-opened");
    };

    const close = () => {
        _o.menuTrigger.classList.remove("active");
        _o.menuWrapper.classList.remove("active");
        _o.body.classList.remove("nav-opened");
    };

    return {
        init: init
    };
})();

export {navigation};
